import { apiClientes } from "../../config/api"
import { getTokenClientes } from "../../Store/storages/AuthenticationStorage"

export const getMinhasSolicitacoes = async (): Promise<any | null> => {
    try{
        const response = await apiClientes.get('Financeiro/GetMinhasSolicitacoes', {
            headers: {Authorization: `Bearer ${await getTokenClientes()}`}
        })
        return response.data
    }catch(error){
        console.log(error)
        return null
    }
}

export const getAnexoSolicitacao = async (idAnexo: string): Promise<{ base64: string} | null> => {
    try {
      const response = await apiClientes.get(`Financeiro/DownloadArquivo?id=${idAnexo}`, {
        headers: { Authorization: `Bearer ${await getTokenClientes()}` }
      });
      if (response?.data?.anexob64) {
        return { base64: response.data.anexob64};
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

export const uploadArquivo = async (extensao: string, arquivo: string): Promise<string | null> => {
  try {
    const response = await apiClientes.post('Financeiro/UploadArquivo', {
      extensao,
      arquivo
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data?.guid || null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const enviarSolicitacao = async (descricao: string, listaAnexosGUID: string[]): Promise<any | null> => {
  try {
    const response = await apiClientes.post('Financeiro/EnviarSolicitacao', {
      descricao,
      listaAnexosGUID
    }, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};